import * as React from "react";
import ParametersContext from "search-filter/contexts/ParametersContext";
import useParameters from "views/hooks/useParameters";
const ParametersContextProvider = ({ children }) => {
  const parametersContext = useParameters();
  return /* @__PURE__ */ React.createElement(ParametersContext.Provider, { value: parametersContext }, children);
};
export default ParametersContextProvider;
